module.exports = __webpack_public_path__ + "img/asset8.6af5bab2.png";